var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulesGenerateCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6515_129447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14H13V16H8V14ZM11.4 10H8V12H14.7C13.4 11.7 12.2 11 11.4 10ZM4 16H6V14H4V16ZM6 10H4V12H6V10ZM18 11.9V18H2V8H10.2C9.9 7.3 9.8 6.6 9.8 5.8C9.8 4.4 10.3 3.1 11.1 2H7V0H5V2H1C0.4 2 0 2.4 0 3V19C0 19.6 0.4 20 1 20H19C19.6 20 20 19.6 20 19V10.9C19.4 11.3 18.7 11.7 18 11.9Z",
    fill: "#525256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5998 5.29999V3.09999H16.6998V5.29999H18.8998V6.39999H16.6998V8.59999H15.5998V6.39999H13.3998V5.29999H15.5998ZM16.1998 11.2C13.1998 11.2 10.7998 8.79999 10.7998 5.79999C10.7998 2.79999 13.1998 0.399994 16.1998 0.399994C19.1998 0.399994 21.5998 2.79999 21.5998 5.79999C21.5998 8.79999 19.1998 11.2 16.1998 11.2ZM16.1998 10.2C18.5998 10.2 20.4998 8.29999 20.4998 5.89999C20.4998 3.49999 18.5998 1.59999 16.1998 1.59999C13.7998 1.59999 11.8998 3.49999 11.8998 5.89999C11.8998 8.29999 13.7998 10.2 16.1998 10.2Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6515_129447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesGenerateCreate);
export default __webpack_public_path__ + "static/media/Schedules-Generate-Create.8292e73b9393f2b4a44d2d339350ccdc.svg";
export { ForwardRef as ReactComponent };